import { useMsal } from '@azure/msal-react';

export function useUserRoles() {
    const { accounts } = useMsal();
    const account = accounts[0];
    const roles = (account?.idTokenClaims?.roles as string[]) ?? [];
    
    return {
        roles,
        isSuperUser: roles.includes('19thView.SuperUser'),
        isClubAdmin: roles.includes('19thView.ClubAdmin'),
    };
}